<label
  class="checkbox"
  for="checkbox-{{ id }}"
  [class.focus]="focus"
  [class.small]="small"
>
  <input
    type="checkbox"
    id="checkbox-{{ id }}"
    [disabled]="disabled"
    [ngModel]="value"
    (ngModelChange)="valueChange.emit($event)"
  />
  <div><ng-content></ng-content></div>
</label>
